import { AccordionSummary, Box, Card, Divider, MenuItem, OutlinedInput, Tab, Tabs, styled } from "@mui/material";

export const FormInfo = styled(Box)(() => ({
  backgroundColor: "#fff7cb",
  margin: "2rem auto 0",
  padding: "1.5rem",
}));

export const PrimaryTabsWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  fontFamily: '"Calibri", sans-serif',
  fontSize: "14px",
  color: "#fff",
  // backgroundColor: '#F0F0F0',
  height: "2rem",
  marginTop: "11px",
  marginBottom: "8px",
}));

export const MainTabs = styled(Tabs)(() => ({
  marginInline: "auto",
}));

export const MainTab = styled(Tab)(() => ({
  "&.MuiTab-root": {
    textTransform: "none",
    paddingInline: "1rem",
    color: "#1F4A7C",
    outline: "none",
  },
  "&.Mui-selected": {
    backgroundColor: "#1F4A7C",
    color: "white",
  },
}));

export const PrimaryTabs = styled(Tabs)(() => ({
  "& .MuiTabs-scroller": {
    justifyContent: "center",
    height: "2rem",
  },
  "& .Mui-selected": {
    backgroundColor: "#5CB85C",
    color: "white",
  },
  "& span": {
    translate: "0 5px",
  },
}));

export const PrimaryTab = styled(Tab)(() => ({
  "&.MuiTab-root": {
    outline: "none",
    fontSize: "12px",
    whiteSpace: "nowrap",
    backgroundColor: "rgb(53, 124, 167)",
    color: "#fff",
    fontFamily: '"Calibri", sans-serif',
    borderRadius: "6px 6px 0px 0px",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 8px",
    minHeight: "30px",
  },
  "&.Mui-selected": {
    // backgroundColor: "rgb(14 55 79)",
    background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
    color: "#fff",
    fontSize: "12px",
    whiteSpace: "nowrap",
    borderRadius: "6px 6px 0px 0px",
    borderBottom: "2px solid rgb(14 55 79)", // corrected typo in 'solid'
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 8px",
    minHeight: "30px",
  },
}));

export const PrimaryTabNewTheme = styled(Tab)(() => ({
  "&.MuiTab-root": {
    outline: "none",
    fontSize: "12px",
    whiteSpace: "nowrap",
    backgroundColor: "rgb(53 124 167)",
    // border: "2px solid rgb(9, 13, 16)",
    color: "#fff",
    fontFamily: '"Calibri", sans-serif',
    borderRadius: "6px 6px 0px 0px",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 8px",
    minHeight: "30px",
  },
  "&.Mui-selected": {
    // background: "linear-gradient(125deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
    background: "linear-gradient(22deg, rgb(14, 55, 79) 0%, rgb(38 86 112) 100%)",
    // backgroundColor: "rgb(14, 55, 79)",
    color: "#fff",
    fontSize: "12px",
    whiteSpace: "nowrap",
    borderRadius: "6px 6px 0px 0px",
    borderBottom: "2px solid rgb(14, 55, 79)", // corrected typo in 'solid'
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 8px",
    minHeight: "30px",
  },
}));

export const MandatoryInfo = styled(Box)(() => ({
  lineHeight: 1,
  fontSize: 14,
  color: "red",
  "& span": {
    display: "inline-block",
    translate: "0 4px",
    fontSize: 18,
  },
}));
export const InfoBox = styled(Box)(() => ({
  lineHeight: 1.5,
  fontSize: "16px",
  color: "#1F4A7C", // Change color as needed
  padding: "8px 16px",
  backgroundColor: "#f0f4fa",
  borderRadius: "1px",
  fontWeight: "600",
  //marginLeft: "30px",
  "& span": {
    display: "inline-block",
    translate: "0 4px",
    fontSize: 18,
  },
}));

export const StyledMenuItem = styled(MenuItem)(() => ({
  "&.MuiMenuItem-root": {
    padding: "0.25rem 0.75rem",
    display: "block",
  },
}));

export const accordionSummaryStyles = {
  // backgroundColor: "rgb(230, 239, 248)",
  height: "1rem",
  minHeight: "48px",
  "&.Mui-expanded": {
    // display: "flex",
    // justifyContent: "space-between",
    backgroundColor: "rgb(230, 239, 248)", // Override the background for expanded state
    minHeight: "48px", // Ensure minHeight is applied in expanded state
    height: "1rem", // Apply the custom height in expanded state as well
  },
};

export const SubTabsWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  fontFamily: '"Calibri", sans-serif',
  fontSize: "14px",
  color: "#fff",
  // backgroundColor: "#F0F0F0",
  height: "2rem",
  marginBottom: "18px",
  // borderBottom: '1px solid #00000038'
}));

// SubTabs and SubTab components
export const SubTabs = styled(Tabs)(() => ({
  "& .MuiTabs-scroller": {
    justifyContent: "center",
    height: "2rem",
  },
  "& .Mui-selected": {
    backgroundColor: "rgb(73, 151, 192)",
    color: "white",
  },
  "& span": {
    translate: "0 5px",
  },
}));

export const SubTab = styled(Tab)(() => ({
  "&.MuiTab-root": {
    outline: "none",
    fontSize: ".85rem",
    backgroundColor: "rgb(53 124 167)",
    color: "#fff",
    fontFamily: '"Calibri", sans-serif',
    borderRadius: "6px 6px 0px 0px",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 16px",
    minHeight: "30px",
  },
  "&.Mui-selected": {
    // backgroundColor: "rgb(14, 55, 79)", // change here!!
    background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",

    color: "#fff",
    fontSize: ".85rem",
    borderRadius: "6px 6px 0px 0px",
    borderBottom: "2px solid rgb(14, 55, 79)", // corrected typo in 'solid'
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 16px",
    minHeight: "30px",
  },
}));

export const SubTabNewTheme = styled(Tab)(() => ({
  "&.MuiTab-root": {
    outline: "none",
    fontSize: ".85rem",
    backgroundColor: "rgb(53 124 167)!important",
    color: "#fff",
    // border: "2px solid rgb(9, 13, 16)",
    fontFamily: '"Calibri", sans-serif',
    // borderRadius: "6px 6px 0px 0px",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 16px",
    minHeight: "30px",
  },
  "&.Mui-selected": {
    // backgroundColor: "rgb(14, 55, 79)!important", // change here!!
    background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)!important",

    color: "#fff",
    fontSize: ".85rem",
    // borderRadius: "6px 6px 0px 0px",
    borderBottom: "2px solid rgb(14, 55, 79)", // corrected typo in 'solid'
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 16px",
    minHeight: "30px",
  },
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  height: "1px" + "!important",
  backgroundColor: "#085A85",
  color: "#1F4A7C",
  alignSelf: "center",
}));

export const PortalWrapper = styled("div")(() => ({
  display: "flex",
  height: "100vh",
  //marginTop: "-5rem",
  width: "100%",
  boxSizing: "border-box",
  overflow: "hidden",
}));
export const SideWrapper = styled("div")(() => ({
  flex: "0 0 15%",
  backgroundColor: "#262D33",
}));
export const SideBarWrapper = styled(Box)(() => ({
  height: "100vh",
  color: "#fff",
  padding: "1rem",
  boxSizing: "border-box",
}));
export const ModuleTextWrapper = styled("h2")(() => ({
  backgroundColor: "#157CB3",
  margin: ".625rem",
  padding: ".5rem",
}));
export const MainWrapper = styled("div")(() => ({
  flex: "0 0 100%",
  padding: "1rem",
  overflowX: "hidden",
  //overflowY: "hidden",
}));
export const FormInputContainer = styled("div")(() => ({
  display: "flex",
  borderRadius: "1px",
  padding: "1.25rem 1.5rem",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "flex-start",
  width: "100%",
  overflow: "auto",
}));
export const RowWrapper = styled("div")(() => ({
  flex: 1,
  gap: "1rem",
  display: "flex",
  flexDirection: "column",
}));
export const StyledOutlinedInput = styled(OutlinedInput)(() => ({
  borderRadius: "5px",
  border: "2px solid #1F4A7C",
}));
export const SummaryCard = styled(Card)(() => ({
  backgroundColor: "rgb(21, 124, 179)",
  //fontFamily: '"Calibri", sans-serif',
}));
export const CustomAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  marginLeft: 0,
  color: "#fff",
  background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
  "& .MuiAccordionSummary-content": {
    margin: 0,
    alignItems: "center",
  },
}));
